import PropTypes from 'prop-types';
import React from 'react';

import { ContentZonesService, LocaleService } from '@sm360/widget-commons-core-services';
import { Vehicle } from '@sm360/widget-commons-vehicle';

import BodyAndFuel from 'vdp-used/components/PhotosAndBodyAndCertifiedSection/BodyAndFuel/BodyAndFuel.jsx';
import Carfax from 'vdp-used/components/PhotosAndBodyAndCertifiedSection/Carfax/Carfax.jsx';
import Certified from 'vdp-used/components/PhotosAndBodyAndCertifiedSection/Certified/Certified.jsx';
import AsTraded from 'vdp-used/components/PhotosAndBodyAndCertifiedSection/AsTraded/AsTraded.jsx';

import 'vdp-used/components/PhotosAndBodyAndCertifiedSection/CertifiedSection.scss';

const CertifiedSection = ({ carfaxKey, carfaxLeadGenerator, certifiedUrl, vehicle, showCarfax }) => {
    const vehicleFlagCertified = vehicle?.certified && <Certified certifiedUrl={certifiedUrl} />;
    const vehicleAsTraded = vehicle?.asTraded && <AsTraded />;

    const carGurusLogoCz = ContentZonesService.getContentZone('widget.vdp.used', 'widget.vdp.used.logo.cargurus');
    const isCarGurusLogoVisible = carGurusLogoCz && carGurusLogoCz.getText() === 'true';
    const carGurusLogoUrl = carGurusLogoCz ? carGurusLogoCz.getImage() : null;

    const carGurusLogo = isCarGurusLogoVisible &&
        carGurusLogoUrl && (
            <div className="showroom-vdp-used-certified-logo">
                <img src={carGurusLogoUrl} alt="CarGurus Logo" className="showroom-vdp-used-certified-logo-cargurus" />
            </div>
        );

    const customLogoCz = ContentZonesService.getContentZone('widget.vdp.used', 'widget.vdp.used.logo.custom');
    const isCustomLogoVisible = customLogoCz && customLogoCz.getText() === 'true';
    const customLogoImgUrl = isCustomLogoVisible ? customLogoCz.getImage() : null;
    const customLogoLinkUrl = isCustomLogoVisible ? customLogoCz.getLink() : null;

    let customLogo = null;
    if (customLogoImgUrl) {
        customLogo = <img src={customLogoImgUrl} alt="Logo" className="showroom-vdp-used-certified-logo-custom-img" />;
        if (customLogoLinkUrl) {
            customLogo = (
                <a
                    href={customLogoLinkUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="showroom-vdp-used-certified-logo-custom-a"
                >
                    {customLogo}
                </a>
            );
        }
        customLogo = <div className="showroom-vdp-used-certified-logo">{customLogo}</div>;
    }

    let history = null;
    if (vehicle?.pastOwner?.description || vehicle?.previousUse?.description) {
        history = (
            <div className="showroom-vdp-used-history-past-owner-previous-use">
                <p className="is-bold">{LocaleService.t('VDP_USED.HISTORY.TITLE')}</p>
                <ul>
                    {vehicle?.pastOwner?.description && (
                        <li>
                            <span className="is-bold">{LocaleService.t('VDP_USED.HISTORY.PAST_OWNER')}: </span>
                            {vehicle.pastOwner.description}
                        </li>
                    )}
                    {vehicle?.previousUse?.description && (
                        <li>
                            <span className="is-bold">{LocaleService.t('VDP_USED.HISTORY.PREVIOUS_USE')}: </span>
                            {vehicle.previousUse.description}
                        </li>
                    )}
                </ul>
            </div>
        );
    }

    return (
        <div className="showroom-vdp-used-photos-features-certified">
            <div className="showroom-vdp-used-features">
                <BodyAndFuel vehicle={vehicle} />
            </div>
            <div className="showroom-vdp-used-certified">
                <Carfax
                    carfaxKey={carfaxKey}
                    carfaxLeadGenerator={carfaxLeadGenerator}
                    vehicle={vehicle}
                    showCarfax={showCarfax}
                />
                {vehicleFlagCertified}
                {vehicleAsTraded}
                <div className="showroom-vdp-used-certified-logos">
                    {carGurusLogo}
                    {customLogo}
                </div>
                {history}
            </div>
        </div>
    );
};

CertifiedSection.defaultProps = {
    carfaxLeadGenerator: false,
};

CertifiedSection.propTypes = {
    carfaxKey: PropTypes.string.isRequired,
    carfaxLeadGenerator: PropTypes.bool,
    certifiedUrl: PropTypes.string.isRequired,
    vehicle: PropTypes.instanceOf(Vehicle.VehicleModelV25).isRequired,
    showCarfax: PropTypes.bool.isRequired,
};

CertifiedSection.displayName = 'CertifiedSection';

export default CertifiedSection;
